function getDefaultSubscriptions() {
    return [];
}

export default getDefaultSubscriptions;
